import React, {useEffect, useState} from 'react';
import {TextField} from "@mui/material"
import {ProjectJson} from "../../api/json/ProjectJson"
import {AnyColumnJson} from "../../api/json/ColumnJson"

interface FieldEditCommonFieldsProps {
    project: ProjectJson
    column?: AnyColumnJson
    name: string
    reference: string
    setName: (newValue: string) => void
    setReference: (newValue: string) => void
    setFieldValid?: (isValid: boolean) => void
}

function ColumnNameAndReferenceInput({ project, column, name, reference, setName, setReference, setFieldValid}: FieldEditCommonFieldsProps) {
    const [nameShort, setNameShort] = useState(false)
    const [displayNameError, setDisplayNameError] = useState(false)
    const [referenceTaken, setReferenceTaken] = useState(false)
    const [referenceShort, setReferenceShort] = useState(false)

    const handleSetName = (name: string) => {
        setName(name)

        if (!column)
            setReference(name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "_"))
    }

    useEffect(() => {
        let referenceTakenValue = false
        if (!column) {
            referenceTakenValue = project.columns.find(it => it.reference === reference) !== undefined
        }

        setReferenceTaken(referenceTakenValue)

        let referenceShortValue = reference.length === 0
        setReferenceShort(referenceShortValue)

        let nameShortValue = name.length === 0
        setNameShort(name.length === 0)

        setFieldValid && setFieldValid(!nameShortValue && !referenceShort && !referenceTakenValue)

    }, [name, reference])

    return (
        <>
            <TextField label="Name"
                       variant="outlined"
                       error={nameShort && displayNameError}
                       value={name}
                       onBlur={() => setDisplayNameError(true)}
                       onChange={(e) => handleSetName(e.target.value)}/>
            <TextField label="Reference"
                       variant="outlined"
                       value={reference}
                       error={referenceTaken}
                       helperText={referenceTaken ? "This reference is already used in the project." : "Unique reference to use in templates."}
                       onChange={(e) => setReference(e.target.value)}/>
        </>
    );
}

export default ColumnNameAndReferenceInput;